/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {Observable} from 'rxjs';
import {SensorsEnumsDataInterface} from 'src/app/shared/interface/settings/system/sesnors';
import {Injectable} from '@angular/core';

@Injectable()
export class MkadSensorUtilsService extends MkadBaseService {
  readonly utilsSensor = URLS_SERVICE.system.sensorUtils;

  constructor() {
    super();
  }

  list(): Observable<SensorsEnumsDataInterface> {
    return this.http.post<SensorsEnumsDataInterface>(this.baseCore + this.utilsSensor.base + this.utilsSensor.data);
  }

}
